// ── CALCULATION ENGINE ──
export function calcIndiaLanded(config, priceData, usdInr) {
  if (!priceData || !usdInr) return null;

  const intlPrice = priceData.price;
  let pricePerIndiaUnit;

  if (config.conversionMode === 'lbToKg') {
    pricePerIndiaUnit = (intlPrice / config.conversionDivisor) * usdInr * (1 + config.dutyRate);
  } else {
    pricePerIndiaUnit = (intlPrice / config.conversionDivisor) * usdInr * (1 + config.dutyRate);
  }

  const result = { perUnit: pricePerIndiaUnit };

  // For precious metals: purity variants
  if (config.showPurity) {
    if (config.purityLabels) {
      // Custom purity labels (e.g., Silver: 999/925/900)
      result.purities = config.purityLabels.map(p => ({
        label: p.label,
        perGram: pricePerIndiaUnit * p.ratio,
        per10g: pricePerIndiaUnit * p.ratio * 10,
        perKg: pricePerIndiaUnit * p.ratio * 1000,
        ratio: p.ratio
      }));
      result.k24 = pricePerIndiaUnit; // primary for backward compat
    } else {
      // Default Gold karat system
      result.k24 = pricePerIndiaUnit;
      result.k22 = pricePerIndiaUnit * (22 / 24);
      result.k18 = pricePerIndiaUnit * (18 / 24);
    }
  }

  // 10g price
  if (config.show10g) {
    result.per10g = pricePerIndiaUnit * 10;
    if (config.showPurity && !config.purityLabels) {
      result.per10g_22k = result.k22 * 10;
      result.per10g_18k = result.k18 * 10;
    }
  }

  // Per-kg price (for Gold & Silver — standard Indian market quote)
  if (config.showKg) {
    result.perKg = pricePerIndiaUnit * 1000;
    if (config.showPurity && !config.purityLabels) {
      result.perKg_22k = result.k22 * 1000;
    }
  }

  // MCX Mini contract prices
  if (config.miniContracts) {
    result.minis = config.miniContracts.map(mc => ({
      name: mc.name,
      lot: mc.lot,
      price: pricePerIndiaUnit * mc.multiplier,
    }));
  }

  return result;
}

// ── FORMATTING ──
export function fmtINR(val, decimals = 2) {
  if (val == null || isNaN(val)) return '—';
  return '₹' + val.toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function fmtUSD(val, decimals = 2) {
  if (val == null || isNaN(val)) return '—';
  return '$' + val.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function fmtChange(change, changePct) {
  if (change == null) return { text: '—', cls: 'neutral' };
  const sign = change >= 0 ? '+' : '';
  const cls = change > 0 ? 'up' : change < 0 ? 'down' : 'neutral';
  const text = `${sign}${change.toFixed(2)} · ${sign}${changePct.toFixed(2)}%`;
  return { text, cls };
}

export function fmtTime(date) {
  if (!date) return '—';
  return new Date(date).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
}

// ── CATEGORY BADGE STYLE ──
export function getCategoryStyle(category, label) {
  switch (category) {
    case 'precious':
      return { background: 'hsl(45 93% 47% / 0.1)', color: 'hsl(45,80%,40%)', border: '1px solid hsl(45 93% 47% / 0.2)' };
    case 'industrial':
      return { background: 'hsl(200 50% 50% / 0.1)', color: 'hsl(200,50%,40%)', border: '1px solid hsl(200 50% 50% / 0.2)' };
    case 'energy':
      if (label === 'Agri Commodity') {
        return { background: 'hsl(100 50% 40% / 0.1)', color: 'hsl(100,50%,35%)', border: '1px solid hsl(100 50% 40% / 0.2)' };
      }
      return { background: 'hsl(0 60% 50% / 0.1)', color: 'hsl(0,60%,45%)', border: '1px solid hsl(0 60% 50% / 0.2)' };
    default:
      return { background: 'var(--l3)', color: 'var(--t3)', border: '1px solid var(--sep2)' };
  }
}
